import styled from "styled-components";
import { MacroTemplateContainer } from "../../styles";

export const TooltipFootnoteTemplatesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

export const TooltipFootnoteTemplateContainer = styled(MacroTemplateContainer)`
  display: grid;
  place-content: center;
  border-radius: 12px;
  height: 80px;
  cursor: pointer;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled.div`
  color: ${({ theme }) => theme.text.text};
  font-size: 16.241px;
  font-weight: 500;
  line-height: 23.202px;
`;

export const Icon = styled.div`
  display: grid;
  place-items: center;
  width: 16px;
  height: 16px;
`;

export const FootnoteText = styled.div`
  color: ${({ clr }) => clr};
  text-align: center;
  font-size: 14.24px;
  font-weight: 500;
  line-height: 23.202px;
`;
